// Feature Flags Configuration
// Updated for frontier market T-bill investment platform

export const FF_FORWARDS_POOL_ENABLED = true;
export const FF_AUCTION_PARTICIPATION_ENABLED = true;
export const FF_PROJECTIONS_ENABLED = true;

// Live arbitrage experiment — visible to forwardsflow_admin / super_admin
export const FF_LIVE_EXPERIMENT_ENABLED = true;

// Legacy flag — kept for backward compatibility but no longer used
export const FF_WHOLESALE_ENABLED = false;

const flags = {
  FF_FORWARDS_POOL_ENABLED,
  FF_AUCTION_PARTICIPATION_ENABLED,
  FF_PROJECTIONS_ENABLED,
  FF_LIVE_EXPERIMENT_ENABLED,
  FF_WHOLESALE_ENABLED,
};

export default flags;
